<template>
  <div id="loading"><b-spinner label="Spinning">Bezig met laden...</b-spinner></div>
</template>

<script>
export default {};
</script>


<style lang="scss">
#loading {
  display: flex;
  justify-content: center;
  
}
</style>
